import { handleActions } from 'redux-actions'
import { fromJS } from 'immutable'

import { NAME } from './constants'

export const initialState = fromJS({
  employees: null,
  activities: [],
  schools: [],
  details: null,
  loading: false,
  joining: false,
  lightboxActive: false,
  loadingMarkerDetails: null,
  markerDetails: null,
})
export default handleActions(
  {
    [NAME]: {
      SET: (state, { payload }) => state.merge(payload),
    },
  },
  initialState,
)



// WEBPACK FOOTER //
// ../source/views/FindActivity/reducer.js